import api from "../api";

export default class BaseService {
  get endpoint() {
    return undefined;
  }

  async getAll() {
    return api.get(this.endpoint);
  }

  async getById(id) {
    return api.get(`${this.endpoint}/${id}`);
  }

  async save(entity) {
    return api.post(this.endpoint, entity);
  }

  async update(entity) {
    return api.put(this.endpoint, entity);
  }

  async deleteById(id) {
    return api.delete(`${this.endpoint}/${id}`);
  }

  async getLast() {
    return api.get(`${this.endpoint}/last`);
  }
}
